import { netsparkAxios } from 'core/services/HTTPService';
import { customersUrl } from './apiUrls';

const putCustomers = (id, params) => netsparkAxios.put(`${customersUrl}${id}/`, params);

export default putCustomers;
